import { Button, ButtonGroup, Modal, TextButton } from '@zillow/constellation-10';

import { EditListingTourConfigSteps } from '../../../constants/EditListingTourConfigModalConstants';

const getSecondaryButtonText = (step: EditListingTourConfigSteps) => {
  switch (step) {
    case EditListingTourConfigSteps.SET_TIME_ZONE:
    case EditListingTourConfigSteps.SET_AVAILABILITY:
      return 'Back';
    default:
      return 'Cancel';
  }
};

const getPrimaryButtonText = (step: EditListingTourConfigSteps) => {
  switch (step) {
    case EditListingTourConfigSteps.SET_BOOKING_METHOD:
    case EditListingTourConfigSteps.SET_TIME_ZONE:
      return 'Next';
    default:
      return 'Save';
  }
};

type EditListingTourConfigModalFooterProps = {
  isPrimaryButtonDisabled: boolean;
  step: EditListingTourConfigSteps;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
};

const EditListingTourConfigModalFooter = ({
  isPrimaryButtonDisabled,
  step,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
}: EditListingTourConfigModalFooterProps) => {
  return (
    <ButtonGroup aria-label="modal actions">
      <Modal.Close>
        <TextButton data-testid="EditListingTourConfigModalFooter-SecondaryBtn" onClick={onSecondaryButtonClick}>
          {getSecondaryButtonText(step)}
        </TextButton>
      </Modal.Close>
      <Button
        data-testid="EditListingTourConfigModalFooter-PrimaryBtn"
        emphasis="filled"
        tone="brand"
        onClick={onPrimaryButtonClick}
        disabled={isPrimaryButtonDisabled}
      >
        {getPrimaryButtonText(step)}
      </Button>
    </ButtonGroup>
  );
};

export default EditListingTourConfigModalFooter;
